
<table datatable class="table tabs-table" *ngIf="!showDeterminantBuilder">
	<thead>
		<tr>
			<th class="cell-order"><i class="fal fa-sort"></i></th>
			<th class="">{{'Determinant' | translate}}</th>
			<th style="min-width: 256px;" class="">{{'Label' | translate}}</th>
			<th class="">{{'Group' | translate}}</th>
			<th class="cell-delete text-center p-0">&nbsp;</th>
			<th class="cell-delete text-center p-0">&nbsp;</th>
			<th class="cell-delete text-center p-0">&nbsp;</th>
		</tr>
	</thead>
	<tbody
		cdkDropList
		[cdkDropListData]="componentTabs?.tabItems"
		(cdkDropListDropped)="dropped($event)">
		<tr cdkDrag *ngFor="let item of componentTabs?.tabItems; let i = index">
			<td cdkDragHandle class="text-center"><small>{{item.sortOrder + 1}}</small></td>
			<td cdkDragHandle>
				<div (click)="openDeterminantModal(item)">
					<determinant-query-readonly *ngIf="!isDeterminantEmpty(item.jsonDeterminants)"
												[jsonDeterminants]="item.jsonDeterminants"
												[determinantMapById]="determinantMapById" ></determinant-query-readonly>
					<small class="workarea__draghere add-in-table" *ngIf="isDeterminantEmpty(item.jsonDeterminants)">{{'Click to add determinant' | translate}}</small>
				</div>
			</td>
			<td>
				<div>
					<input class="form-control"
						type="text"
						name="label"
						[(ngModel)]="item.label"
						[rangeLength]="[2, 256]"
						(input)="labelChanged(item)"
						(blur)="save()"
						(focus)="disableSave()"
						placeholder="{{ 'Label' | translate }}"
						style="border-top-right-radius:0;border-bottom-right-radius:0;"
						required />
				</div>
			</td>
			<td class="text-center">
				<select class="form-control" [size]="'small'" (change)="onItemGroupChanged($event, item)" [(ngModel)]="item.group">
					<option value=""></option>
					<option *ngFor="let item1 of componentTabs?.tabItems" [value]="item1.key" [hidden]="item1.key === item.key">{{item1.label}}</option>
				</select>
			</td>
			<td class="text-center p-0">
				<i class="far cursor-pointer {{ (item.hidden == null || !item.hidden) ? 'fa-eye' : 'fa-eye-slash'}}"
				(click)="toggleVisibleRow(i)"></i>
			</td>
			<td class="text-center p-0">
				<i *ngIf="i!==0" class="fas fa-times btn-xs btn-bordered btn-danger btn-icon false mx-1"
					(click)="deleteRow(i)"></i>
			</td>
			<td class="text-center p-0">
				<div class="btn-group tab-icon-dropdown" dropdown [insideClick]="true" placement="bottom right"
							(isOpenChange)="extraPropsDropdownOpenChanged($event)">
					<button dropdownToggle type="button" class="dropdown-toggler">
							<i class="fa-solid fa-ellipsis-vertical"></i>
					</button>
					<div *dropdownMenu class="dropdown-menu dropdown-menu-right">
						<table>
							<tbody>
								<tr>
									<td>{{ 'Working label' | translate }}</td>
									<td>
										<div>
                                            <input class="form-control form-control-sm"
                                                   type="text"
                                                   name="workingLabel"
                                                   [(ngModel)]="item.workingLabel"
                                                   [rangeLength]="[2, 256]"
                                                   (change)="changeData()"
                                                   style="border-top-right-radius:0;border-bottom-right-radius:0;"
                                            />
										</div>
									</td>
								</tr>
                                <tr>
                                    <td>{{ 'Top separator' | translate }}</td>
                                    <td>
                                        <div>
                                            <input class="form-control form-control-sm"
                                                   type="checkbox"
                                                   name="hasTopSeparator"
                                                   [checked]="item.hasTopSeparator"
                                                   [(ngModel)]="item.hasTopSeparator"
                                                   (change)="changeData()"
                                            />
                                        </div>
                                    </td>
                                </tr>
								<tr>
									<td>{{ 'Icon' | translate }}</td>
									<td>
										<ng-select [items]="icons"
																bindLabel="name"
																bindValue="value"
																groupBy="group"
																(change)="changeData()"
																[multiple]="false"
																[(ngModel)]="item.icon">
											<ng-template ng-optgroup-tmp let-oitem="item">
												{{ oitem.group }}
											</ng-template>
											<ng-template ng-option-tmp let-oitem="item">
												<span class="icon-name">{{ oitem.name }}</span><i [class]="oitem.value"></i>
											</ng-template>
											<ng-template ng-label-tmp let-oitem="item">
												<span class="icon-name">{{ oitem.name }}</span><i [class]="oitem.value"></i>
											</ng-template>
										</ng-select>
									</td>
								</tr>
								<tr>
									<td>{{ 'Show' | translate }}</td>
									<td>
										<div class="btn-group" btnRadioGroup [(ngModel)]="item.titleMode"
													(ngModelChange)="changeData()">
											<label class="btn" btnRadio="label">{{ 'Label' | translate }}</label>
											<label class="btn"
															btnRadio="icon-label">{{ 'Icon & Label' | translate }}</label>
											<label class="btn" btnRadio="icon">{{ 'Icon' | translate }}</label>
										</div>
									</td>
								</tr>
								<tr *ngIf="item.titleMode == 'icon-label'">
									<td>{{ 'Icon position' | translate }}</td>
									<td>
										<div class="btn-group" btnRadioGroup [(ngModel)]="item.iconPosition"
											(ngModelChange)="changeData()">
											<label class="btn" btnRadio="left">{{ 'Left' | translate }}</label>
											<label class="btn" btnRadio="top">{{ 'Top' | translate }}</label>
											<label class="btn" btnRadio="right">{{ 'Right' | translate }}</label>
										</div>
									</td>
								</tr>
								<tr>
									<td>{{ 'Behaviour' | translate }}</td>
									<td>
										<confirmation-popover
											placement="left"
											className="btn btn-outline-danger btn-sm"
											[label]="'Clear behaviour' | translate"
											question="Clear the behaviour linked to this tab?"
											(onConfirmed)="clearBehaviour(item)">
										</confirmation-popover>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</td>
		</tr>
		<tr>
			<td class="text-center">&nbsp;</td>
			<td> </td>
			<td>
				<div>
					<input class="form-control form-control-sm"
						type="text"
						name="label"
						[(ngModel)]="newRow.label"
						[rangeLength]="[2, 256]"
						(input)="labelChanged(newRow)"
						placeholder="{{ 'Label' | translate }}"
						style="border-top-right-radius:0;border-bottom-right-radius:0;"
						required />
				</div>
			</td>
			<td class="text-center" colspan="4">
				<button class="btn btn-outline-primary" type="button"
					(click)="addNewRow()" [hidden]="isAddButtonDisabled()">Add</button>
				<span class="error text-danger" *ngIf="!isAddButtonDisabled()">
					{{ 'Dont forget!' | translate }}
				</span>
			</td>
		</tr>
	</tbody>
</table>

<!-- determinant window -->
 <!--
<div class="row layer sub-layer mt-0" id="detFromFormio"
    [ngClass]="{'sub-layer-active': showDeterminantBuilder, 'hidden': !showDeterminantBuilder}" *ngIf="showDeterminantBuilder">
    <layer-header (closeLayer)="closeDeterminantLayer()" (setListView)="setListView($event)" [listToggle]="listToggle"
        [listIcons]=false title="{{'Apply determinant' | translate}}" [customClass]="'mt-0'" *ngIf="store.state.common.determinantSection.topLayer !== 'edit'">
        <ng-content></ng-content>
    </layer-header>
    <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
	class="row layer sub-layer onTop-sub-layer" id="newDetFromFormio" [serviceId]="serviceId" [isOnSubLayer]="true"
        [determinant]="store.state.common.determinantSection.determinant" (formSubmit)="closeEdit()"
        (editCancel)="closeEdit()"></determinant-new>
    <div class="row {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}}">
        <div class="col-12">
            <div class="row">
                <determinant-builder-new [serviceId]="serviceId" [jsonString]="selectedRow.jsonDeterminants"
                                         [determinantMapById]="determinantMapById"
                                         (onChange)="selectedRow.jsonDeterminants = $event"
                                         (onSave)="updateDeterminant($event);closeDeterminantLayer()"
                    (onCancel)="closeDeterminantLayer()" class="col-12">
                </determinant-builder-new>
            </div>
        </div>
	</div>
</div>
-->

<drawer [title]="'Manage determinants'" [isClosed]="!showDeterminantBuilder" (saveEvent)="updateDeterminant($event)" [embedded]=true (closeEvent)="closeDeterminantLayer();" class="text-left in-modal-drawer">
    <div class="drawer-content drawer-direct-content">
        <determinant-manager
            *ngIf="serviceId && selectedRow && showDeterminantBuilder"
            [serviceId]="serviceId"
            [determinantMapById]="determinantMapById"
            [jsonString]="selectedRow.jsonDeterminants"
            (builderUpdated)="tempDeterminant = $event"
            [showBuilder]=true
            (cancel)="closeDeterminantLayer()"
            (updateHeader)="showModalHeader($event)"
            class="d-flex overflow-hidden mh-100 h-100 w-100">
        </determinant-manager>
    </div>
</drawer>
